import { useState } from 'react';
import { forgetIdentity } from '../net';

/**
 * This browser is the player: it keeps the secret that resumes a seat. On a
 * shared device that is worth being able to throw away on purpose.
 */
export function IdentitySetting() {
  const [asking, setAsking] = useState(false);
  return <>
    <div className="section-label">Guest identity</div>
    <p className="sub" style={{ fontSize: 'var(--fs-sm)', margin: '0 0 8px' }}>
      This browser remembers you so a refresh puts you back in your city. Other players see your
      name and an id; the server also sees your network address, used only to limit abuse.
    </p>
    <button className={`btn sm ${asking ? 'danger' : ''}`} onClick={() => {
      if (!asking) { setAsking(true); return; }
      forgetIdentity();
      location.reload();
    }}>{asking ? 'Forget me? Press again' : 'New guest identity'}</button>
    {asking && <p className="sub" style={{ fontSize: 'var(--fs-sm)', marginTop: 6 }}>
      Any city you command passes to an NPC, and this device can no longer return to it.
    </p>}
  </>;
}
